export default {
    isPortalReady: false,
    portal: {
        banners: [],
        categorias: [],
        contenidos: [],
        created_date: '',
        descripcion: '',
        dominio: '',
        id: 0,
        id_pais: 0,
        nombre: '',
        pais_portal: {
            id: 0,
            pais: ''
        },
        pasarelas: [],
        status: 0,
        token: '',
        update_date: '',
        esperandoUrlPago: false,
        productos_portal: []
    },
    site: {
        isPortalLoginModalVisible: false,
        isPortalRegistroModalVisible: false,
        isTransferenciaModalVisible: false,
        isCompletarPerfilModalVisible: false,
        isBarraPrecioFooter: false,
        isSiteMenuVisible: false,
        isLoadingUser: false,
        isLoadingUserVideos: false,
        isLoadingUserCompras: false,
        didLoadUserVideos: false,
        didLoadUser: false,
        didLoadUserCompras: false,
        isLoadingCookie: false,
        setPasarelaPago: []
    },
    user: {
        id: 0,
        mis_compras: [],
        mis_compras_regaladas: [],
        mis_compras_moviles: [],
        mis_compras_pendientes: [],
        mis_compras_app: [],
        mis_regalos: [],
        videos: []
    }
}
